export const CompensationIcon = () => (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.333 11.333v2a.667.667 0 0 1-.666.667h-10A.666.666 0 0 1 2 13.333V6.667A.667.667 0 0 1 2.667 6h10a.667.667 0 0 1 .666.667v2"
            stroke="#7F8898"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m11.473 6 1.194-1.707L9.393 2 6.587 6h4.886ZM6.06 2.667 3.72 6h2.867L8 4 6.06 2.667Zm7.94 6h-3.333a.667.667 0 0 0-.667.666v1.334a.667.667 0 0 0 .667.666H14V8.667Z"
            stroke="#7F8898"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
